export default __webpack_public_path__ + "static/media/uploadNew.23c3b1b9.svg";